import { REPORT, SHOW_TOAST, DISMISS_TOAST } from "./constants";

export const reportLayout = layout => ({
  type: REPORT,
  layout
});

export const showToast = message => ({
  type: SHOW_TOAST,
  message
});

export const dismissToast = () => ({
  type: DISMISS_TOAST,
});



// WEBPACK FOOTER //
// ./src/app/layout/actions.js